<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <!-- <a href="/static/dataimport/import_apartment_sample.xlsx" download="import_apartment_sample">Download</a> -->
      <a @click="exportExcelFile">{{ $t("common.exportFileExcel") }}</a>
    </div>
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <!-- <template slot="statusImport" slot-scope="row">
        <p style="color:green" v-if="row.item.statusImport == 'PASS'">{{ row.item.statusImport }}</p>
        <p style="color:red" v-else>{{ row.item.statusImport }}</p>
      </template> -->
      <template v-slot:cell(statusImport)="row">
        <p style="color:green" v-if="row.item.statusImport == 'PASS'">{{ row.item.statusImport }}</p>
        <p style="color:red" v-else>{{ row.item.statusImport }}</p>
      </template>
    </b-table>
    <div v-if="numberRecordProcessed">
      <span>{{ $t('common.numberRecordProcessed') }}<b>{{ numberRecordProcessed }}</b></span>
    </div>
    <div v-if="numberRecordFailed">
      <span>{{ $t('common.numberRecordFailed') }}<span style="color: red;"><b>{{ numberRecordFailed }}</b></span></span>
    </div>
    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-default"
        @click="CancelList"
        style="margin-right: 5px;"
      >
        {{ $t("common.close") }}
      </button>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";

import { mapGetters, mapActions } from "vuex";
import Enum from "../../../enum/enum";
import XLSX from "xlsx";
// import utils from "@/lib/utils";

export default {
  name: "ApartmentImportExcel",
  components: {
    UploadExcelComponent,
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a
      numberRecordProcessed: null,
      numberRecordFailed: null,
      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "apartment_code",
          label: "apartment.apartment_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],

      validateElement: {},
      apartmentCodeKey: "Mã Căn Hộ",
      apartmentSizeKey: "Diện Tích",
      ownerNameKey: "Họ và Tên",
      ownerEmailKey: "Email",
      isLoading: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
      "ON_SHOW_TOAST",
      "IMPORT_APARTMENT"
    ]),
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },
    checkHeaderInExcelFile: function(headerInExcelFile) {
      let results = "OK";
      let headerRequired = ["Mã Căn Hộ", "Diện Tích"];
      let headerValidateArray = [];
      for (let i = 0, size = headerInExcelFile.length; i < size; i++) {
        if (headerRequired.includes(headerInExcelFile[i].trim())) {
          headerValidateArray.push(headerInExcelFile[i].trim());
        }
      }
      let arrayResult = headerRequired.filter(
        x => !headerValidateArray.includes(x)
      );
      if (arrayResult.length > 0) {
        results = this.$t("invoice.importExcel.notiNotFoundHeader", {
          "0": arrayResult[0]
        });
      }
      return results;
    },
    handleSuccess({ results, header }) {
      let validateFile = this.checkHeaderInExcelFile(header);
      if (validateFile === "OK") {
        this.tableData = results;
        let data = {
          headers: header,
          dataImport: results,
          domain: Enum.domain
        };
        // init empty
        this.resultImportList = [];
        this.isLoading = true
        this.IMPORT_APARTMENT(data).then(
          function(res) {
            this.numberRecordProcessed = res.numberRecordProcessed
            this.numberRecordFailed = res.numberRecordFailed
            res.dataResult.forEach(v => {
              let dataPass = {
                apartment_code: v.apartment_code,
                statusImport: v.result,
                errorDetail: v.error
              };
              this.resultImportList.push(dataPass);
            });
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function() {
            let dataError = {
              apartment_code: "Unknown",
              statusImport: "FAIL",
              errorDetail: "Unknown"
            };

            this.resultImportList.push(dataError);
            this.isLoading = false
          }.bind(this)
        );

        this.tableHeader = header;
      } else {
        this.showError(validateFile);
      }
    },
    CancelList: function() {
      this.$router.push({
        name: "ApartmentList"
      });
    },
    exportExcelFile: function() {
      let data_list = [];
      let json_data = [
        {
          "Mã Căn Hộ": "A05.14",
          "Diện Tích": 50,
          "Ghi chú": "",
          "Họ và Tên": "",
          Email: "",
          SĐT: "",
          "Địa chỉ": ""
        },
        {
          "Mã Căn Hộ": "A05.15",
          "Diện Tích": 50,
          "Ghi chú": "",
          "Họ và Tên": "Nguyen Van A",
          Email: "nguyena@gmail.com",
          SĐT: "",
          "Địa chỉ": ""
        }
      ];

      data_list = json_data;
      // export json to Worksheet of Excel
      // only array possible
      var invoiceFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, invoiceFile, "file mẫu"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "import_apartment_sample.xlsx"); // name of the file is 'book.xlsx'
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentImportExcel.vue